import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

export function getTopSalesSuperIntendenciaCompaniesCharts(data, year) {
  // param: data list of: [
  // {
  //   empresa: 'BIOALIMENTAR CIA. LTDA.',
  //   venta1: 59435181,
  //   sector: 'GANADERÍA / AVICULTURA / PEQUEÑAS ESPECIES / MICELÁNEOS',
  //   $$hashKey: 'uiGrid-000V'
  // }]
  var verticalChartlabels = [];
  var ventas = [];

  data.forEach((element) => {
    verticalChartlabels.push(element.empresa);
    ventas.push(element.venta1);
  });

  return (
    <div>
      <VerticalBarChart
        icon={{ color: "info", component: "leaderboard" }}
        title={`Año ${year}`}
        description="Ventas por Empresas"
        chart={{
          labels: verticalChartlabels,
          datasets: [
            {
              label: "Ventas " + year + "($)",
              color: "dark",
              data: ventas,
            },
          ],
        }}
      />
    </div>
  );
}
